module.exports = __webpack_public_path__ + "img/comingsoon.de9e46e1.svg";